var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-alert',{staticClass:"mb-4",attrs:{"type":"info","tile":""}},[_c('strong',[_vm._v("PREVIEW: ")]),_vm._v("This is how the disclaimer will appear in the browser.\n  ")]),_vm._v(" "),_c('DisclaimerCard',{attrs:{"disclaimer":_vm.disclaimer,"mockup":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }